<template>
  <v-tab-item key="content" value="content">
    <v-row>
      <v-col>
        <div class="pa-4 pt-6 pb-lg-0 subdued rounded-lg">
          <v-row class="px-4 px-md-0 mx-md-2 mx-lg-4">
            <ContentTypeSelection
              class="pb-6 py-lg-0"
              :content-type="contentType"
              :content-types="contentTypes"
              @content-type-selected="contentTypeSelected"
            ></ContentTypeSelection>
            <CommunityContentSearch @search="onSearch"></CommunityContentSearch>
          </v-row>
          <v-row class="px-4 px-md-0 mx-md-2 mx-lg-4">
            <QuestionSelection
              v-if="community.journalId"
              :community="community"
              :question="question"
              @question-selected="questionSelected"
            ></QuestionSelection>
            <CollectionSelection
              v-if="collections.length"
              :collection="collection"
              :collections="collections"
              @collection-selected="collectionSelected"
            ></CollectionSelection>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <SelectedArticles
          ref="selectedArticles"
          :title="'Community Content'"
          :articles="communityContentToDisplay"
          :show-content-type="showContentTypeCommunity"
          :content-count="communityContent.length"
          :announce-results-updated-text="announceResultsUpdatedText"
        />
        <div v-if="!communityContent.length">
          <p
            :key="communityContent.length"
            class="pa-5 text-center"
            role="status"
            aria-atomic="true"
          >
            No matching results found
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="isCommunityContentExceededLimit && showLimitedCommunityContent"
    >
      <v-col>
        <div class="text-center">
          <v-btn
            :aria-label="ariaLabel"
            outlined
            rounded
            @click="showAllCommunityContent"
          >
            View All
            <span class="d-sr-only">&nbsp;{{ community.name }} content</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-tab-item>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

import SelectedArticles from "~/components/articles/SelectedArticles.vue";
import ContentTypeSelection from "~/components/communities/ContentTypeSelection";
import CollectionSelection from "~/components/communities/CollectionSelection";
import QuestionSelection from "~/components/communities/QuestionSelection";
import CommunityContentSearch from "~/components/communities/CommunityContentSearch";

const COMMUNITY_CONTENT_LIMIT = 15;

export default {
  name: "CommunityContentTab",
  components: {
    ContentTypeSelection,
    QuestionSelection,
    CollectionSelection,
    SelectedArticles,
    CommunityContentSearch,
  },

  props: {
    community: { type: Object, default: () => ({}) },
    communityContent: { type: Array, default: () => [] },
    question: { type: Object, default: () => undefined },
    contentType: { type: Object, default: () => undefined },
    contentTypes: { type: Array, default: () => [] },
    collection: { type: Object, default: () => undefined },
    collections: { type: Array, default: () => [] },
  },
  data() {
    return {
      showLimitedCommunityContent: true,
      announceResultsUpdatedText: false,
    };
  },
  computed: {
    ...mapFlags(["showContentTypeCommunity"]),
    communityContentToDisplay() {
      const limitedCommunityContent = [...this.communityContent].slice(
        0,
        COMMUNITY_CONTENT_LIMIT
      );
      return this.showLimitedCommunityContent
        ? limitedCommunityContent
        : this.communityContent;
    },
    ariaLabel() {
      return `View More ${this.community.name} content button`;
    },
    isCommunityContentExceededLimit() {
      return this.communityContent.length > COMMUNITY_CONTENT_LIMIT;
    },
    currentTab() {
      return this.$route.query.show;
    },
  },
  watch: {
    currentTab: {
      immediate: true,
      handler() {
        this.announceResultsUpdatedText = false;
      },
    },
  },
  methods: {
    showAllCommunityContent() {
      this.showLimitedCommunityContent = false;
      this.$nextTick(() => {
        this.$refs.selectedArticles.focusItem(COMMUNITY_CONTENT_LIMIT);
      });
    },
    questionSelected(question) {
      this.announceResultsUpdatedText = true;
      this.$emit("question-selected", question);
    },
    contentTypeSelected(contentType) {
      this.announceResultsUpdatedText = true;
      this.$emit("content-type-selected", contentType);
    },
    collectionSelected(collection) {
      this.announceResultsUpdatedText = true;
      this.$emit("collection-selected", collection);
    },
    onSearch(searchTerm) {
      this.announceResultsUpdatedText = true;
      this.$emit("search", searchTerm);
    },
  },
};
</script>
